/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { TipoRegistrazioneDTO } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ottiene l'elenco dei tipi registrazione ordinati per codice
 * @summary Elenco Tipi registrazione
 */
export const getBackTipiRegistrazione = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoRegistrazioneDTO[]>(
    {
      url: `/framework-bo-procedimenti/tipi-registrazione`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackTipiRegistrazioneQueryKey = () =>
  [`/framework-bo-procedimenti/tipi-registrazione`] as const;

export const getGetBackTipiRegistrazioneQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackTipiRegistrazione>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBackTipiRegistrazione>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getBackTipiRegistrazione>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackTipiRegistrazioneQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackTipiRegistrazione>>
  > = ({ signal }) => getBackTipiRegistrazione(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackTipiRegistrazioneQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackTipiRegistrazione>>
>;
export type GetBackTipiRegistrazioneQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Tipi registrazione
 */
export const useGetBackTipiRegistrazione = <
  TData = Awaited<ReturnType<typeof getBackTipiRegistrazione>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBackTipiRegistrazione>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackTipiRegistrazioneQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
